module.exports = __webpack_public_path__ + "static/img/home3.bfb1d660.png";